import React from "react";
import { getFromStorage } from '../utils/storage';
import ListSubscriptions from "./ListSubscriptions";
import AccountVerified from "./AccountVerified.js";

class MySubscriptions extends React.Component {

  render() {
    let language1 = null
    if(getFromStorage('language') !== null){
      language1 = require(`../utils/language_`+getFromStorage('language')); 
    }else{
      language1 = require(`../utils/language_gb`); 
    }
    let language = language1.language;
    return (
      <>
        <div className="content">
          <AccountVerified  notify={this.props.notify}/>
          <ListSubscriptions />
        </div>
      </>
    );
  }
}

export default MySubscriptions;
